import { render, staticRenderFns } from "./DateListItemSkeleton.vue?vue&type=template&id=6c444f8a&"
import script from "./DateListItemSkeleton.vue?vue&type=script&lang=ts&"
export * from "./DateListItemSkeleton.vue?vue&type=script&lang=ts&"
import style0 from "./DateListItemSkeleton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SkeletonRect: require('/tmp/build_71ad00c4/src/components/skeleton/Rect.vue').default})
